import { useQuery } from '@biletiniz/apollo';
import { FLIGHT_BOOKING_INFO_QUERY } from './gql';

export const useFlightBookingInfo = ({ session }) => {
  const flightBookingInfo = useQuery(FLIGHT_BOOKING_INFO_QUERY, {
    variables: {
      session,
    },
    fetchPolicy: 'no-cache',
  });
  return {
    flightBookingInfo: flightBookingInfo?.data?.flightBookingInfo,
    loadFlightBookingInfoError: flightBookingInfo?.error?.message,
    isLoadingFlightBookingInfo: flightBookingInfo.loading,
  };
};
